/**
 * Format a currency value for display inside an input (commas, no symbol).
 * Use when the input has its own $ adornment. For full currency in copy/read-only text, use formatCurrencyAmount.
 * Accepts strings that may already contain commas or decimals (e.g. from API "200.0" or "1,000").
 */
export function formatCurrencyInputValue(value: string): string {
  if (value === '') return '';
  const num = Number(value.replace(/,/g, ''));
  return Number.isNaN(num) ? value : num.toLocaleString('en-US', { maximumFractionDigits: 0 });
}
